<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-1/3 flex lg:mr-3 mb-4"></div>
			<div class="lg:w-2/3 flex justify-end">
				<ButtonBlack class="mr-1">
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="pdf_fields"
			:section="section"
			:itemsTable="itemsTable"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import { queryContractFieldsList } from '@/apollo/queries/admin/contract_fields'

export default {
	apollo: {
		pdf_fields: queryContractFieldsList()
	},
	data() {
		return {
			search: '',
			section: 'variable',
			itemsTable: 'pdf_fields',
			itemsTitles: ['Id', 'Nombre', 'Tabla', 'Campo', 'Variable']
		}
	},
	components: { ListTable }
}
</script>

<style scoped>
.w-24R {
	width: 24rem;
}
</style>
